// src/App.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './App.css';

import NavBar from './components/Navbar';
import Footer from './components/Footer';
import BackgroundSmileys from './components/BackgroundSmileys';
import Seo from './components/Seo';
import SiteNavJsonLd from './components/SiteNavJsonLd.jsx';

// pagina-componenten
import Home from './pages/Home';
import About from './pages/About';
import ServicesPage from './pages/Services';
import Portfolio from './pages/Portfolio';
// import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Cookies from './pages/Cookies';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

// Linktree & Tools (zonder layout)
import LinkPage from './pages/LinkPage';
import LinkToolsPage from './pages/LinkToolsPage';

const routeConfig = [
  {
    path: '/',
    element: <Home />,
    title: 'Online Growth Club | Websites & SEO die klanten opleveren',
    description:
      'Wil jij online beter gevonden worden? Bij OnlineGrowthClub.nl bouwen we converterende websites, beheren SEO & SEA en regelen jouw social media — alles gericht op meer klanten, meer groei.',
  },
  {
    path: '/over-ons',
    element: <About />,
    title: 'Over Ons | Online Growth Club',
    description:
      'Leer meer over OnlineGrowthClub.nl: wie we zijn, wat we doen en waarom we het verschil maken in jouw online zichtbaarheid.',
  },
  {
    path: '/diensten',
    element: <ServicesPage />,
    title: 'Diensten | Online Growth Club',
    description:
      'Onze diensten: van webdesign tot SEO, SEA en social media beheer. Alles wat je nodig hebt om online te groeien.',
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
    title: 'Portfolio | Online Growth Club',
    description:
      'Bekijk onze afgeronde projecten en zie hoe we bedrijven helpen groeien met effectieve websites en online marketing.',
  },
  // {
  //   path: '/blog',
  //   element: <Blog />,
  //   title: 'Blog | Online Growth Club',
  //   description:
  //     'Lees onze blog voor tips over SEO, webdevelopment, online marketing en alles om je website te laten groeien.',
  // },
  {
    path: '/contact',
    element: <Contact />,
    title: 'Contact | Online Growth Club',
    description:
      'Neem contact op met OnlineGrowthClub.nl voor een vrijblijvende groeiscan of adviesgesprek over jouw online strategie.',
  },
  {
    path: '/cookies',
    element: <Cookies />,
    title: 'Cookieverklaring | Online Growth Club',
    description:
      'Lees hoe OnlineGrowthClub.nl cookies gebruikt om je gebruikservaring te verbeteren en de website te optimaliseren.',
  },
  {
    path: '/privacy',
    element: <Privacy />,
    title: 'Privacyverklaring | Online Growth Club',
    description:
      'Ontdek hoe wij bij OnlineGrowthClub.nl omgaan met jouw persoonsgegevens en jouw rechten volgens de AVG.',
  },
  {
    path: '/terms',
    element: <Terms />,
    title: 'Algemene Voorwaarden | Online Growth Club',
    description:
      'Bekijk hier de algemene voorwaarden van OnlineGrowthClub.nl die van toepassing zijn op al onze diensten en overeenkomsten.',
  },
];

export default function App() {
  return (
    <HelmetProvider>
      <Routes>
        {/* Standalone Linktree en Tools zonder NavBar/Footer */}
        <Route path="/links" element={<LinkPage />} />
        <Route path="/links/tools" element={<LinkToolsPage />} />

        {/* Alle overige routes met standaard layout */}
        <Route
          path="*"
          element={
            <>
              <BackgroundSmileys />
              <NavBar />
              <Routes>
                {routeConfig.map(({ path, element, title, description }) => (
                  <Route
                    key={path}
                    path={path}
                    element={
                      <>
                        <Seo title={title} description={description} path={path} />
                        {path === '/' && <SiteNavJsonLd />}
                        {element}
                      </>
                    }
                  />
                ))}

                {/* Extra placeholders (optioneel) */}
                <Route path="/faq" element={<Placeholder title="FAQ" />} />
                <Route path="/register" element={<Placeholder title="Registreren" />} />
                <Route path="/login" element={<Placeholder title="Inloggen" />} />
              </Routes>
              <Footer />
            </>
          }
        />
      </Routes>
    </HelmetProvider>
  );
}

const Placeholder = ({ title }) => (
  <main className="p-5">
    <h1 className="text-3xl font-semibold">{title}</h1>
  </main>
);
